import React, { useState, useRef } from "react";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import MenuList from "@material-ui/core/MenuList";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";
import SaveIcon from "@material-ui/icons/Save";
import { makeStyles } from "@material-ui/core/styles";
import { Controller } from "react-hook-form";
import { useCurl } from "zh-common-modules";
import { FILE_DOWNLOAD_GET } from "config/url";
const useStyles = makeStyles((theme) => ({
    root: {
        position: "relative"
    },
    paper: {
        position: "absolute",
        zIndex: 1
    },
    menuItem: {
        padding: "0px 35px 0px 10px"
    },
    editButton: {
        position: "absolute",
        right: 0
    }
}));
function HookFormDownload(props) {
    const { value, 
    // onChange
    label } = props;
    const missionTime = 300;
    const mission = useRef();
    const { curl } = useCurl();
    const inputRef = useRef();
    const [open, setOpen] = useState(false);
    const classes = useStyles();
    const showValue = `${value.length}个文件`;
    const selectSchema = value.map((value) => {
        const { uid, name } = value;
        return {
            value: uid,
            label: name
        };
    });
    const handleClick = () => {
        setOpen(true);
    };
    const enterInput = () => {
        setOpen(true);
    };
    const leaveInput = () => {
        mission.current = setTimeout(() => {
            setOpen(false);
        }, missionTime);
    };
    const enterMenu = () => {
        if (open) {
            clearTimeout(mission.current);
            mission.current = void 0;
        }
        else {
            setOpen(true);
        }
    };
    const leaveMenu = () => {
        setOpen(false);
    };
    const handleDownload = (id) => () => {
        curl.download(FILE_DOWNLOAD_GET, { fileId: id }, { method: "get" });
    };
    return (<div className={classes.root}>
      <TextField ref={inputRef} value={showValue} variant="standard" onMouseEnter={enterInput} onMouseLeave={leaveInput} onClick={handleClick} fullWidth label={label} inputProps={{
        readOnly: true
    }}/>
      {open && <Paper className={classes.paper}>
        <MenuList onMouseEnter={enterMenu} onMouseLeave={leaveMenu}>
        {selectSchema.map((menu, index) => {
        const { value, label } = menu;
        return <MenuItem key={index} className={classes.menuItem}>
            {label}
            <IconButton size="small" className={classes.editButton} onClick={handleDownload(value)}>
              <SaveIcon />
            </IconButton>
          </MenuItem>;
    })}
        </MenuList>
      </Paper>}
    </div>);
}
export default function HookFormDownloadWraper(props) {
    const { name, control, label, value } = props;
    return <Controller as={HookFormDownload} control={control} name={name} label={label} defaultValue={value}/>;
}
